import script from "./DreLayoutAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./DreLayoutAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./DreLayoutAdministrar.vue?vue&type=style&index=0&id=64db515b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64db515b"]])

export default __exports__